import _ from 'lodash'
import 'whatwg-fetch'
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import apiURL from './api'

import { Glyphicon, Alert, Table, Col, FormGroup, FormControl, Button, Panel, HelpBlock } from "react-bootstrap";

const rrTypes = [
  "ANY",
  "A",
  "AAAA",
  "TXT",
  "CNAME",
  "MX",
  "NS",
  "CAA",
];

const errors = {
  2: "SERVFAIL: Server failed to complete the DNS request",
  3: "NXDOMAIN: Domain name does not exist",
  5: "REFUSED: The server refused to answer for the query",
}

export const rrIdToName = {
  1: "A",
  2: "NS",
  3: "MD",
  4: "MF",
  5: "CNAME",
  6: "SOA",
  7: "MB",
  8: "MG",
  9: "MR",
  10: "NULL",
  11: "WKS",
  12: "PTR",
  13: "HINFO",
  14: "MINFO",
  15: "MX",
  16: "TXT",
  17: "RP",
  18: "AFSDB",
  19: "X25",
  20: "ISDN",
  21: "RT",
  22: "NSAP",
  23: "NSAP-PTR",
  24: "SIG",
  25: "KEY",
  26: "PX",
  27: "GPOS",
  28: "AAAA",
  29: "LOC",
  30: "NXT",
  31: "EID",
  32: "NIMLOC",
  33: "SRV",
  34: "ATMA",
  35: "NAPTR",
  36: "KX",
  37: "CERT",
  38: "A6",
  39: "DNAME",
  40: "SINK",
  41: "OPT",
  42: "APL",
  43: "DS",
  44: "SSHFP",
  45: "IPSECKEY",
  46: "RRSIG",
  47: "NSEC",
  48: "DNSKEY",
  49: "DHCID",
  50: "NSEC3",
  51: "NSEC3PARAM",
  52: "TLSA",
  53: "SMIMEA",
  54: "Unassigned",
  55: "HIP",
  56: "NINFO",
  57: "RKEY",
  58: "TALINK",
  59: "CDS",
  60: "CDNSKEY",
  61: "OPENPGPKEY",
  62: "CSYNC",
  99: "SPF",
  100: "UINFO",
  101: "UID",
  102: "GID",
  103: "UNSPEC",
  104: "NID",
  105: "L32",
  106: "L64",
  107: "LP",
  108: "EUI48",
  109: "EUI64",
  249: "TKEY",
  250: "TSIG",
  251: "IXFR",
  252: "AXFR",
  253: "MAILB",
  254: "MAILA",
  255: "*",
  256: "URI",
  257: "CAA",
  258: "AVC",
  259: "DOA",
  32768: "TA",
  32769: "DLV",
}
  
class DNSForm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      hostname: props.hostname,
      record: props.record,
    }

    this.updateHostname = this.updateHostname.bind(this);
    this.updateRecord = this.updateRecord.bind(this);

    this.updateData = this.updateData.bind(this);

  }

  updateHostname(event) {
    this.setState({"hostname": event.target.value});
  }

  updateRecord(event) {
    this.setState({"record": event.target.value});
  }

  updateData(event) {
    event.preventDefault();
    this.props.onSubmit(this.state.hostname, this.state.record);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hostname: nextProps.hostname,
      record: nextProps.record,
    })
  }

  render() {
    return (
      <Panel>
        <Panel.Heading>DNS Lookup</Panel.Heading>
        <Panel.Body>
        <form onSubmit={this.updateData}>
            <FormGroup>
              <Col sm={9}>
                <FormControl type="text" value={this.state.hostname} onChange={this.updateHostname} />
                <HelpBlock>Fetch records from DNS by entering the desired hostname here.</HelpBlock>
              </Col>
              <Col sm={2}>
                  <FormControl componentClass="select" value={this.state.record} onChange={this.updateRecord}>
                  {rrTypes.map((rr) => <option key={rr}>{rr}</option>)}
                </FormControl>
              </Col>
              <Col sm={1}>
                <Button type="submit" bsStyle="primary">Lookup</Button>
              </Col>
            </FormGroup>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

class DNSResult extends Component {

  render() {

    // No data

    if (this.props.data == null) {
      return null;
    }

    // Error from server

    if (this.props.data.Status !== 0) {

      var msg = "Unknown error";

      if (this.props.data.Status in errors) {
        msg = errors[this.props.data.Status];
      }

      return (
          <Alert bsStyle="danger">{msg}</Alert>
      )

    }

    let dnssec = this.props.data.AD ? <Alert bsStyle="success"><Glyphicon glyph="ok" />&nbsp;&nbsp;DNSSEC used and validated successfully</Alert> : "";

    // Empty reply

    if (!("Answer" in this.props.data)) {

      return (
        <div>
          <Alert bsStyle="warning">Record not found</Alert>
          {dnssec}
        </div>
      )

    }

    return (
      <div>
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{width: "40px", textAlign: "center"}}>Record</th>
              <th style={{width: "60px", textAlign: "center"}}>TTL</th>
              <th>Text</th>
            </tr>
          </thead>
          <tbody>
          {this.props.data.Answer.map((answer) => 
            <tr>
              <td style={{width: "40px", textAlign: "center"}}><tt>{rrIdToName[answer.type]}</tt></td>
              <td style={{width: "60px", textAlign: "center"}}><tt>{answer.TTL}</tt></td>
              <td><tt>{answer.data}</tt></td>
            </tr>
          )}
          </tbody>
        </Table>
        {dnssec}
      </div>
    );
  }
}

class BaseDNSTool extends Component {
  
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateData = this.updateData.bind(this);

    this.state = {
      hostname: "hostname" in props.match.params ? props.match.params.hostname : "spf.ubivox.com",
      record: "record" in props.match.params ? props.match.params.record : "TXT",
      data: null,
    };
   
  }

  componentDidMount() {
    this.updateData();
  }

  componentDidUpdate() {

    let requestedHostname = _.get(this, "props.match.params.hostname", "ubivox.com");
    let requestedRecord = _.get(this, "props.match.params.record", "TXT");

    if (requestedHostname === this.state.hostname && requestedRecord === this.state.record) {
      return
    }

    // Reset state, this is a page change

    this.setState({
      hostname: requestedHostname,
      record: requestedRecord,
      data: null,
    }, this.updateData)

  }

  handleSubmit(hostname, record) {

    const hostnameChanged = _.get(this, "props.match.params.hostname", "") !== hostname;
    const recordChanged = _.get(this, "props.match.params.record", "") !== record;

    if (hostnameChanged || recordChanged) {
      this.props.history.push(`/dns/${hostname}/${record}`);
    }

    this.setState({
      hostname: hostname,
      record: record,
    }, this.updateData);

  }

  updateData() {

    var url = new URL(apiURL);
    var params = {
      name: this.state.hostname,
      type: this.state.record,
    };

    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    fetch(url).then((res) => res.json()).then((data) => this.setState({data: data}));

  }

  render() {
    return (
      <div>
        <DNSForm hostname={this.state.hostname} record={this.state.record} onSubmit={this.handleSubmit}/>
        <DNSResult data={this.state.data} />
      </div>
    );
  }

}

const DNSTool = withRouter(BaseDNSTool);

export default DNSTool;



// WEBPACK FOOTER //
// ./src/DNS.js